import { render, staticRenderFns } from "./GPSRInfoCopyPage.vue?vue&type=template&id=fd1186f6&scoped=true&"
import script from "./GPSRInfoCopyPage.vue?vue&type=script&lang=ts&"
export * from "./GPSRInfoCopyPage.vue?vue&type=script&lang=ts&"
import style0 from "./GPSRInfoCopyPage.vue?vue&type=style&index=0&id=fd1186f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd1186f6",
  null
  
)

export default component.exports